<!--
 * AI证件核对：切到本 tab 时向后端申请短期票据，以 iframe 嵌入 A 侧审核详情页
-->
<template>
    <div class="ml_ai_certificate">
        <div v-if="embedUrl" class="ml_ai_toolbar">
            <a-button size="small" type="primary" :loading="loading" @click="refresh">
                <a-icon type="reload" /> 刷新
            </a-button>
        </div>
        <div v-if="embedUrl" class="ml_ai_iframe_box">
            <iframe
                :key="embedUrl"
                :src="embedUrl"
                frameborder="0"
                width="100%"
                height="100%"
                allowfullscreen
                @error="onIframeError"
            ></iframe>
        </div>
        <a-empty v-else :description="loading ? '正在加载 AI 审核页面...' : 'AI 证件核对页面加载失败'" />
    </div>
</template>

<script>
import { getAiAuditAccess } from "@/api/order";

export default {
    name: "orderAiCertificate",
    props: {
        orderObj: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            embedUrl: "",
            loading: false,
            retrying: false
        };
    },
    mounted() {
        this.loadAccess();
    },
    methods: {
        loadAccess() {
            const orderNumber = this.orderObj && this.orderObj.orderNumber;
            if (!orderNumber) {
                return;
            }
            this.loading = true;
            getAiAuditAccess(orderNumber)
                .then(res => {
                    if (res && res.data && res.data.embedUrl) {
                        this.embedUrl = res.data.embedUrl;
                    } else {
                        this.embedUrl = "";
                    }
                })
                .catch(() => {
                    this.embedUrl = "";
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        refresh() {
            // 手动刷新：重新申请票据并重载 iframe
            this.loadAccess();
        },
        onIframeError() {
            // iframe 加载失败（如票据失效）时自动重取一次
            if (this.retrying) {
                return;
            }
            this.retrying = true;
            setTimeout(() => {
                this.retrying = false;
                this.loadAccess();
            }, 500);
        }
    }
};
</script>

<style lang="scss" scoped>
.ml_ai_certificate {
    width: 100%;
    height: calc(100vh - 200px);
    min-height: 600px;
    display: flex;
    flex-direction: column;
}

.ml_ai_toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background-color: #fafafa;
    border-bottom: 1px solid #e8e8e8;
}

.ml_ai_iframe_box {
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 600px;
    background-color: #fafafa;
}
</style>
